import {
  AddressDto,
  AttachmentTypeDto,
  CarStatusDto,
  ContactInfoTypeDto,
  ContactStatusDto,
  CustomerFlagDto,
  CustomerStatusDto,
  CustomerTypeDto,
  DictionaryTypeDto,
  ProcessStatusDto,
  ResourceTypeDto,
  SupplierStatusDto,
  TaskCompletionModeDto,
  TaskStatusDto,
  UnitMeasurementDto,
  UpdateEmailContentTypeDto,
} from '@/api/generated';

export type Address = Record<keyof AddressDto, string>;
export type CarStatusOptionsTranslation = Record<CarStatusDto, string>;
export type ContactStatusOptionsTranslation = Record<ContactStatusDto, string>;
export type CustomerStatusOptionsTranslation = Record<CustomerStatusDto, string>;
export type CustomerTypeOptionsTranslation = Record<CustomerTypeDto, string>;
export type DictionariesTranslation = {
  booleanOptions: BooleanOptionsTranslation;
  carStatusOptions: CarStatusOptionsTranslation;
  contactInfoTypeOptions: ContactInfoTypeOptionsTranslation;
  contactStatusOptions: ContactStatusOptionsTranslation;
  customerStatusOptions: CustomerStatusOptionsTranslation;
  customerTypeOptions: CustomerTypeOptionsTranslation;
  dictionaryTypeOptions: DictionaryTypeOptionsTranslation;
  emailAttachmentTypeOptions: EmailAttachmentTypeOptionsTranslation;
  emailContentTypeOptions: UpdateEmailContentTypeOptionsTranslation;
  flagOptions: FlagOptionsTranslation;
  processStatusOptions: ProcessStatusTranslation;
  resourceTypeOptions: ResourceTypeTranslation;
  supplierStatusOptions: SupplierStatusOptionsTranslation;
  taskCompletionModeOptions: TaskCompletionModeOptionsTranslation;
  taskStatusOptions: TaskStatusOptionsTranslation;
};
export type DictionaryTypeOptionsTranslation = Record<DictionaryTypeDto, string>;
export type EmailAttachmentTypeOptionsTranslation = Record<AttachmentTypeDto, string>;
export type FlagOptionsTranslation = Record<CustomerFlagDto, string>;
export type ProcessStatusTranslation = Record<ProcessStatusDto, string>;
export type SupplierStatusOptionsTranslation = Record<SupplierStatusDto, string>;
export type TaskCompletionModeOptionsTranslation = Record<TaskCompletionModeDto, string>;
export type TaskStatusOptionsTranslation = Record<TaskStatusDto, string>;
export type UnitOptionsTranslation = Record<UnitMeasurementDto, string>;
export type UpdateEmailContentTypeOptionsTranslation = Record<UpdateEmailContentTypeDto, string>;

export const taskCompletionModeOptionsTranslation: TaskCompletionModeOptionsTranslation = {
  [TaskCompletionModeDto.AssigneeCompletes]: 'Kończone przez wykonawcę',
  [TaskCompletionModeDto.CreatorApproved]: 'Zatwierdzane przez twórcę',
};

export const taskStatusOptionsTranslation: TaskStatusOptionsTranslation = {
  [TaskStatusDto.Canceled]: 'Anulowane',
  [TaskStatusDto.Done]: 'Zakończone',
  [TaskStatusDto.DoneNotConfirmed]: 'Zakończone (niepotwierdzone)',
  [TaskStatusDto.InProgress]: 'W trakcie',
  [TaskStatusDto.New]: 'Nowe',
  [TaskStatusDto.Postponed]: 'Odłożone',
  [TaskStatusDto.Rejected]: 'Odrzucone',
};

type BooleanOptionsTranslation = {
  false: string;
  true: string;
};

export const customerTypeOptionsTranslation: CustomerTypeOptionsTranslation = {
  [CustomerTypeDto.Business]: 'Biznesowy',
  [CustomerTypeDto.ForeignBusiness]: 'Zagraniczny',
  [CustomerTypeDto.Individual]: 'Indywidualny',
};

export const carStatusOptionsTranslation: CarStatusOptionsTranslation = {
  [CarStatusDto.Active]: 'W użyciu',
  [CarStatusDto.Inactive]: 'Wyłączony z użycia',
};

export type ContactInfoTypeOptionsTranslation = Record<ContactInfoTypeDto, string>;

export const contactInfoTypeOptionsTranslation: ContactInfoTypeOptionsTranslation = {
  [ContactInfoTypeDto.Email]: 'Adres email',
  [ContactInfoTypeDto.Phone]: 'Numer telefonu',
};

export const emailContentTypeOptions: UpdateEmailContentTypeOptionsTranslation = {
  [UpdateEmailContentTypeDto.CakeInstallationAgencies]: '11. AKTYWNA Cake installation – agencje',
  [UpdateEmailContentTypeDto.CakeInstallationCompanies]:
    '10. AKTYWNA Cake installation – korporacje',
  [UpdateEmailContentTypeDto.ChristmasOffer]: '08. AKTYWNA Oferta świąteczna',
  [UpdateEmailContentTypeDto.Custom]: '00. Własne',
  [UpdateEmailContentTypeDto.DecisionQuestionRequest]: '04. Pytanie co z decyzją',
  [UpdateEmailContentTypeDto.Easter2026]: '!! AKTYWNA Wielkanoc 2026',
  [UpdateEmailContentTypeDto.FatThursday]: '15. AKTYWNA Tłusty czwartek',
  [UpdateEmailContentTypeDto.ForumEventCompanies]: '14. Podziękowania forum branży eventowej',
  [UpdateEmailContentTypeDto.General]: '07. AKTYWNA Oferta ogólna',
  [UpdateEmailContentTypeDto.GrazingTable]: '09. AKTYWNA Grazing Table',
  [UpdateEmailContentTypeDto.OpenDayFoksal]: '16. Dzień otwarty - Pałac na Foksal',
  [UpdateEmailContentTypeDto.OpinionRequest]: '06. Prośba o opinię',
  [UpdateEmailContentTypeDto.PostEventFollowUp]: '05. Podziękowanie po event-cie',
  [UpdateEmailContentTypeDto.ResponseAsSoonAsPossible]: '01. Zapytanie – szybka odpowiedź',
  [UpdateEmailContentTypeDto.ResponseAsSoonAsPossibleWithRequestVerification]:
    '02. Opcjonalnie - weryfikacja potrzeb',
  [UpdateEmailContentTypeDto.SendingOffer]: '03. Wysyłka oferty',
  [UpdateEmailContentTypeDto.SixFloorTheatre]: '12. AKTYWNA Oferta Teatru 6. Piętro',
  [UpdateEmailContentTypeDto.SixFloorTheatreOpenDay]: '13. AKTYWNA Dzień otwarty Teatru 6. Piętro',
};

export const emailAttachmentsTypeOptions: EmailAttachmentTypeOptionsTranslation = {
  [AttachmentTypeDto.CakeInstallation]: 'Cake Installation',
  [AttachmentTypeDto.Christmas2025]: 'Oferta świąteczna',
  [AttachmentTypeDto.Easter2026Album]: 'Wielkanoc 2026 - Album',
  [AttachmentTypeDto.Easter2026Offer]: 'Wielkanoc 2026 - Oferta',
  [AttachmentTypeDto.GeneralOffer]: 'Oferta ogólna',
  [AttachmentTypeDto.GrazingTable]: 'Grazing Table',
};

export const flagOptionsTranslation: FlagOptionsTranslation = {
  [CustomerFlagDto.Green]: 'Zaakceptowany do realizacji',
  [CustomerFlagDto.Red]: 'Odrzuć zamówienie',
  [CustomerFlagDto.Yellow]: 'Wymaga weryfikacji',
};

export const customerStatusOptionsTranslation: CustomerStatusOptionsTranslation = {
  [CustomerStatusDto.Active]: 'Aktywny',
  [CustomerStatusDto.Inactive]: 'Nieaktywny',
  [CustomerStatusDto.Prospect]: 'Prospekt',
  [CustomerStatusDto.Rejected]: 'Odrzucony',
};

const booleanOptionsTranslations: BooleanOptionsTranslation = {
  false: 'Nie',
  true: 'Tak',
};

export const addressTranslation: Address = {
  community: 'Gmina',
  county: 'Powiat',
  flatNo: 'Numer mieszkania',
  houseNo: 'Numer domu',
  locality: 'Miejscowość',
  postCode: 'Kod pocztowy',
  province: 'Województwo',
  street: 'Ulica',
};

export const processStatusOptionsTranslation: ProcessStatusTranslation = {
  [ProcessStatusDto.Canceled]: 'Anulowany',
  [ProcessStatusDto.Created]: 'Nowy',
  [ProcessStatusDto.Finished]: 'Zakończony',
  [ProcessStatusDto.InProgress]: 'W trakcie',
};

export const dictionaryTypeOptionsTranslation: DictionaryTypeOptionsTranslation = {
  [DictionaryTypeDto.CarType]: 'Auta',
  [DictionaryTypeDto.DietaryPreference]: 'Preferencja żywieniowa',
  [DictionaryTypeDto.EmergencyContactCategoryType]: 'Numery awaryjne',
  [DictionaryTypeDto.MenuType]: 'Rodzaj Menu',
  [DictionaryTypeDto.PackageOfferItem]: 'Element oferty',
  [DictionaryTypeDto.PredefinedOffer]: 'Oferta predefiniowana',
  [DictionaryTypeDto.Room]: 'Sala',
  [DictionaryTypeDto.SupplierType]: 'Rodzaj dostawcy',
  [DictionaryTypeDto.Tag]: 'Tagi',
};

export const unitMeasurementOptionsTranslation: UnitOptionsTranslation = {
  [UnitMeasurementDto.Day]: 'dni',
  [UnitMeasurementDto.Gram]: 'gramy',
  [UnitMeasurementDto.Hour]: 'godziny',
  [UnitMeasurementDto.Meter]: 'metry',
  [UnitMeasurementDto.Milliliter]: 'ml',
  [UnitMeasurementDto.Package]: 'opakowania',
  [UnitMeasurementDto.People]: 'osoby',
  [UnitMeasurementDto.Person]: 'osoba',
  [UnitMeasurementDto.Unit]: 'sztuki',
};

export const supplierStatusOptionsTranslation: SupplierStatusOptionsTranslation = {
  [SupplierStatusDto.Active]: 'Aktywny',
  [SupplierStatusDto.Inactive]: 'Nieaktywny',
};

export type ResourceTypeTranslation = Record<ResourceTypeDto, string>;

export const resourceTypeTranslation: ResourceTypeTranslation = {
  [ResourceTypeDto.Car]: 'Auto',
  [ResourceTypeDto.Chat]: 'Czat',
  [ResourceTypeDto.Contact]: 'Kontakt',
  [ResourceTypeDto.Customer]: 'Klient',
  [ResourceTypeDto.Email]: 'Email',
  [ResourceTypeDto.IncidentTicket]: 'Incydent',
  [ResourceTypeDto.Offer]: 'Oferta',
  [ResourceTypeDto.Process]: 'Proces',
  [ResourceTypeDto.Supplier]: 'Dostawca',
  [ResourceTypeDto.Task]: 'Zadanie',
  [ResourceTypeDto.User]: 'Użytkownik',
};

export const contactStatusOptionsTranslation: ContactStatusOptionsTranslation = {
  [ContactStatusDto.Active]: 'Aktywny',
  [ContactStatusDto.Inactive]: 'Nieaktywny',
};

export const dictionariesTranslation: DictionariesTranslation = {
  booleanOptions: booleanOptionsTranslations,
  carStatusOptions: carStatusOptionsTranslation,
  contactInfoTypeOptions: contactInfoTypeOptionsTranslation,
  contactStatusOptions: contactStatusOptionsTranslation,
  customerStatusOptions: customerStatusOptionsTranslation,
  customerTypeOptions: customerTypeOptionsTranslation,
  dictionaryTypeOptions: dictionaryTypeOptionsTranslation,
  emailAttachmentTypeOptions: emailAttachmentsTypeOptions,
  emailContentTypeOptions: emailContentTypeOptions,
  flagOptions: flagOptionsTranslation,
  processStatusOptions: processStatusOptionsTranslation,
  resourceTypeOptions: resourceTypeTranslation,
  supplierStatusOptions: supplierStatusOptionsTranslation,
  taskCompletionModeOptions: taskCompletionModeOptionsTranslation,
  taskStatusOptions: taskStatusOptionsTranslation,
};
